<template>
  <div>
    <p class="title text-left">种梨13年，河北农民老梁的“鸭梨”</p>
    <p class="desc text-left">2018-10-12　<span class="author">及时雨小额贷款</span></p>
    <div class="main-content text-left">
      <p class="normal">民间有句谚语：“一颗荔枝三把火，日食斤梨不为多。”入秋后，正是吃梨的好季节。在风干秋燥的午后，吃上一个梨既能静心解渴还能清肺润燥。可是你知道么？你吃的梨有河北赵县“老梁”的一份力。</p>
      <p class="normal">老梁，河北赵县农民，今年49岁，谁也不曾想到，过去的他还是一个本分只会种大田作物的农民，2005年因积极响应政策改种梨，从一个农业户摇身一变成了村里的种梨大户，并坚持了13年，成为了赵县梨业的佼佼者。</p>
      <p class="bold"><span>农民老梁有个“脱贫”梦</span></p>
      <p class="normal">出身于河北赵县农村的老梁，自小家庭贫困，全家5口人，仅靠着父母几亩地生活。从小他就跟着父母下地干活，可是父母年纪越来越大，身体状况越来越不乐观，为了改善家里经济情况，老梁下定决心一定要脱离贫困。</p>
      <div class="normal"><img src="../img/custDetail/3-01.png" width="100%" alt=""></div>
      <p class="normal">2005年为响应政府的号召，也为了寻求更好的发展，原来以种植玉米、小麦等大田作物为主的老梁毫不犹豫的把10几亩农作物改种了梨树，从此之后一种就是13年，这13年里老梁用心的学习种梨技术，种出的梨个大、水分多又甜，销量也非常好，成了村里的种梨大户。</p>
      <p class="bold"><span>土平房，摇身一变“小别墅”</span></p>
      <p class="normal">13年的种梨生涯给老梁的生活带来了很大的改观。小时候住的土平房，已经摇身一变成了“独栋小别墅” 他说道“种梨子让我的生活更好了，日子也越来越好，以前种地赚不到几个钱，一家人过得紧巴巴的，现在好多了”</p>
      <div class="normal"><img src="../img/custDetail/3-02.png" width="100%" alt=""><p class="text-center">老梁的新房</p></div>
      <p class="normal">可是靠天吃饭的产业，在天灾面前显得如此不堪一击。由于去年春季天气寒冷，导致梨减产，老梁通过出售梨获得的收入比以往少了将近一半。而今年7月份又到了给梨施肥的季节，眼看着别人家已经在给梨施肥了，老梁却看着自己10几亩梨发愁。</p>
      <p class="normal">他说道“到时候如果不施肥，这些梨子就长不好，后面收梨子的季节，没有包装箱的话，梨子也不好卖啊。”看着挂在树上的梨，他心急如焚。4万多买化肥和包装箱的资金缺口，让老梁一下慌了神。</p>
      <p class="bold"><span>种梨大户遭遇进退两难</span></p>
      <p class="normal">时间一天天过去，持续无解的困境，让老梁焦头烂额。“这是我们一家人的生活支撑”老梁一脸无奈的说道，“我们这样的农民，去银行借款，需要很多流程，等款下来，梨子都要熟了。”</p>
      <p class="normal">“跟亲戚朋友借，也不好开口，大家都是农民，也没多少余钱”，于是老梁咨询了村里一位德高望重的站长，“站长信誉高有文化，平时大家有问题都会来问问他”老梁介绍道。于是站长跟他推荐了及时雨小贷，“我这个年纪也能借款，刚开始真不太相信，还以为是高利贷。”老梁笑言</p>
      <p class="normal">在站长的帮助下，老梁填写了相关借款信息，没几天平台信贷人员就来到他家实地探访，老梁说道“他们来我家看了我家里的情况，还让我带他们去我的梨园看我们家的梨子，问了我每年产多少梨，可以赚多少钱，还看了我的银行资金流水等”</p>
      <p class="normal">实地探访过程中他也向信贷经理咨询了借贷的利息和期限，双方经过沟通后，老梁觉得放款周期短，利率也较低，在他能接受的范围内。于是很快与信贷人员确定了合作意向。</p>
      <div class="normal"><img src="../img/custDetail/3-03.png" width="100%" alt=""><p class="text-center">信贷经理与老梁</p></div>
      <p class="normal">经过及时雨小贷的线下尽调和的线上数据风控，在双方的撮合下，他很快就拿到了4万元的借款，并顺利买了化肥和包装箱，赶在梨成熟的季节开始施肥。</p>
      <p class="normal">老梁不懂线下资产，更不了解线上风控，他只知道，及时雨小贷为他填补了曾经让他寸步难行的资金缺口，而且完全不是他最初认为的什么高利贷。</p>
      <p class="bold"><span>收获季，今年老梁的梨特别甜</span></p>
      <p class="normal">河北赵县是中国梨业的主要产出地，年产量约占全国的1/3。今年4月份，许小年教授与及时雨小贷高管一行来到赵县曹庄，对农村金融需求进行调研，学习了解当地企业针对农村贫困的商业化解决方案。</p>
      <div class="normal"><img src="../img/custDetail/3-04.png" width="100%" alt=""><p class="text-center">年初许小年教授在赵县调研</p></div>
      <p class="normal">许小年教授认为：之前传统的金融机构以及一些新兴的互联网公司都尝试过三农金融业务，但没有找到成功模式，原因是他们的终端无法下沉到村里，没有实现低成本业务扩张。要发展农村金融，应关注到农村“人情社会”的属性，需用新的风控方法来适应农村信用环境。</p>
      <p class="normal">如今及时雨小贷已与河北宜农科技达成战略合作，未来将在服务三农领域有更深入的配合，共同探索“金融+科技”解决农村金融市场需求。</p>
      <p class="normal">今年9月份，老梁站在梨园拍了一张照片发了给信贷人员。他还说道“感谢你们，我的日子越来越有盼头了”</p>
      <p class="normal">我们从老梁的照片中可以看到如今的他脸上已有平和的笑容，似乎在告诉我们他已经取得了大丰收。</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Detail3"
  }
</script>

<style scoped lang="less">
  @import "detail.less";
</style>



// WEBPACK FOOTER //
// src/components/Detail3.vue